import { AnimatePresence, motion } from 'framer-motion';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
}
export const Glow: FC<Props> = ({ className }) => {
  return (
    <AnimatePresence>
      <div className={twMerge('', className)}>
        <motion.div
          className='absolute top-0 left-0 
                   h-full w-full blur-[17.5px]'
          style={{
            background:
              'linear-gradient(90deg, rgba(83,152,247,.5), rgba(114,39,241,.5), rgba(125,16,166,.5))',
          }}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
        />

        <motion.div
          className='absolute top-0 left-0 
                   h-full w-full blur-[17.5px]'
          style={{
            background:
              'linear-gradient(90deg, rgba(125,16,166,.5), rgba(114,39,241,.5), rgba(83,152,247,.5))',
          }}
          animate={{ opacity: [1, 0.5, 1] }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1.5,
          }}
        />
      </div>
    </AnimatePresence>
  );
};
